import { useTranslation } from 'react-i18next';
import { Panel } from '../components/Panel';

/** Vistas que se construyen en las siguientes semanas (M2/M3): la pantalla existe, el contenido llega después. */
export function Placeholder() {
  const { t } = useTranslation();
  return (
    <Panel title={t('placeholder.title')} description={t('placeholder.description')}>
      <div className="empty">{t('placeholder.body')}</div>
    </Panel>
  );
}
